import React from 'react';
import Grid from '@mui/material/Grid';

import { Formik } from 'formik';
import * as Yup from 'yup';

import FormControl from '@mui/material/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
// import Checkbox from '@mui/material/Checkbox';
// import FormControlLabel from '@mui/material/FormControlLabel';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

import TransitionsModal from '../../component/TransitionsModal';
import { useSelector } from 'react-redux';

const NewServiceRequest = ({newSR, handleCloseNewRS, handleSaveNewRS}) => {

    const home = useSelector((state) => state.home);
    const auth = useSelector((state) => state.auth);

    const assets = home.assets;
    const typesOfService = home.typesOfService;
    const userFullName =  auth.fullName;
    const userId = auth.id;
    const email = auth.email;

    const initialValues = {
        asset: {
            code: '',
            description: '',
        },
        costCenter: '',
        openingTime: '',
        solicitation: '',
        serviceType: {
            code: '',
            description: '',
        },
        supervisor: '',
        requester: userId + ' ' + userFullName,
        extensionNumber: '',
        email: email,
        maquinaParada: null,
        dtIniParada: null,
        hrIniParada: null,
    };

    const newSRSchema = Yup.object().shape({
        asset: Yup.object({
            code: Yup.string().required('Obrigatório'),
            description: Yup.string().required('Obrigatório'),
        }),
        costCenter: Yup.string()
            .required('Obrigatório'),
        solicitation: Yup.string()
            .required('Obrigatório'),
        serviceType: Yup.object({
            code: Yup.string().required('Obrigatório'),
            description: Yup.string().required('Obrigatório'),
        }),
        requester: Yup.string()
            .required('Obrigatório'),
        extensionNumber: Yup.string()
            .required('Obrigatório'),
        email: Yup.string()
            .required('Obrigatório'),
        maquinaParada: Yup.string().default(null).nullable().required('Obrigatório'),
        dtIniParada: Yup.object().default(null).nullable()
            .when('maquinaParada', {
                is: '1',
                then: Yup.object().default(null).nullable().required('Obrigatório'),
                otherwise: Yup.object().default(null).nullable().notRequired()
            }),
        hrIniParada: Yup.object().default(null).nullable()
            .when('maquinaParada', {
                is: '1',
                then: Yup.object().required('Obrigatório'),
                otherwise: Yup.object().default(null).nullable().notRequired()
            })
    });

    const handleSubmit = (form) => {

        const formToSend = {
            asset: form.asset.code,
            serviceType: form.serviceType.code,
            extensionNumber: form.extensionNumber,
            email: form.email,
            solicitation: form.solicitation,
            costCenter: form.costCenter,
            maquinaParada: form.maquinaParada,
            dtIniParada: form.maquinaParada && form.dtIniParada !== null ? form.dtIniParada.format('DD/MM/YYYY') : '',
            hrIniParada: form.maquinaParada && form.hrIniParada !== null ? form.hrIniParada.format('HH:mm') : '',
        }

        handleSaveNewRS(formToSend);

    };

    return(

        <TransitionsModal
            title={`Nova SS`}
            open={newSR}
        >

            <Box sx={{bgcolor: 'background.paper'}}>

                <Formik
                    validationSchema={newSRSchema}
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validateOnMount
                    >

                        {({
                            values,
                            isValid,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue,
                            resetForm
                        }) => (
                            
                            <FormControl fullWidth sx={{padding: 1}}>

                                <Grid container spacing={1}>

                                    <Grid item xs={12} sm={6}>

                                        <Autocomplete 
                                            isOptionEqualToValue={(option, value) => option.code === value.code}
                                            getOptionLabel={(item) =>  item.code + ' - ' + item.description }
                                            noOptionsText='Não localizado'
                                            id='asset'
                                            name='asset'
                                            disablePortal
                                            fullWidth
                                            options={assets || []}
                                            onChange={(e, newValue) => {
                                                setFieldValue('asset',
                                                    newValue !== null ? newValue : values.asset
                                                );
                                                setFieldValue('costCenter',
                                                    newValue !== null ? newValue.costCenter + ' ' + newValue.descCostCenter : ''
                                                );
                                            }}
                                            renderInput={(params) => (
                                                <TextField 
                                                    margin='dense'
                                                    label='Bem'
                                                    fullWidth
                                                    name='asset'
                                                    {...params}
                                                />
                                            )}
                                        />

                                    </Grid>

                                    <Grid item xs={12} sm={6}>

                                        <TextField
                                            id='costCenter'
                                            name='costCenter'
                                            label='Centro de Custo/Trabalho'
                                            fullWidth
                                            margin='dense'
                                            disabled
                                            value={values.costCenter}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />

                                    </Grid>

                                    <Grid item xs={12} sm={12}>

                                        <TextField
                                            id='solicitation'
                                            name='solicitation'
                                            label='Solicitação'
                                            multiline
                                            minRows={6}
                                            maxRows={6}
                                            fullWidth
                                            placeholder='Descrição da solicitação'
                                            value={values.solicitation}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />

                                    </Grid>

                                    <Grid item xs={12} sm={4}>

                                        <Autocomplete
                                            isOptionEqualToValue={(option, value) => option.code === value.code}
                                            getOptionLabel={(item) =>  item.code + ' - ' + item.description }
                                            noOptionsText='Não localizado'
                                            id='maquinaParada'
                                            name='maquinaParada'
                                            disablePortal
                                            fullWidth
                                            options={[{description: 'Sim', code: '1'}, {description: 'Não', code: '2'}]}
                                            onChange={(e, newValue) => {
                                                setFieldValue('maquinaParada', newValue !== null ? newValue.code : null);

                                                if(newValue === null || newValue.code !== '1'){
                                                    setFieldValue('dtIniParada', null);
                                                    setFieldValue('hrIniParada', null);
                                                }

                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    margin='dense'
                                                    label='Máquina Parada'
                                                    fullWidth
                                                    name='maquinaParada'
                                                    {...params}
                                                />
                                            )}
                                        />

                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                sx={{marginTop: '8px', width: '100%'}}
                                                label="Data Início da Parada"
                                                disableFuture
                                                disabled={values.maquinaParada !== '1'}
                                                value={values.dtIniParada === '' ? null : values.dtIniParada}
                                                format='DD/MM/YYYY'
                                                onChange={(newValue) => {
                                                    setFieldValue('dtIniParada', newValue);
                                                }}
                                                clearable={true}
                                                slotProps={{ textField: { variant: 'outlined', clearable: true } }}
                                            />
                                        </LocalizationProvider>
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <TimePicker
                                                sx={{marginTop: '8px', width: '100%'}}
                                                label="Hora Início da Parada"
                                                disableFuture
                                                disabled={values.maquinaParada !== '1'}
                                                value={values.hrIniParada === '' ? null : values.hrIniParada}
                                                ampm={false}
                                                onChange={(newValue) => {
                                                    setFieldValue('hrIniParada', newValue);
                                                }}
                                                clearable={true}
                                                slotProps={{ textField: { variant: 'outlined', clearable: true } }}
                                            />
                                        </LocalizationProvider>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>

                                        <Autocomplete
                                            isOptionEqualToValue={(option, value) => option.code === value.code}
                                            getOptionLabel={(item) =>  item.code + ' - ' + item.description }
                                            noOptionsText='Não localizado'
                                            id='serviceType'
                                            name='serviceType'
                                            disablePortal
                                            fullWidth
                                            options={typesOfService || []}
                                            onChange={(e, newValue) => {
                                                setFieldValue('serviceType',
                                                newValue !== null ? newValue : values.serviceType
                                                );
                                            }}
                                            sx={{mr: 0.5}}
                                            renderInput={(params) => (
                                                <TextField
                                                    margin='dense'
                                                    label='Tipo de Serviço'
                                                    fullWidth
                                                    name='serviceType'
                                                    {...params}
                                                />
                                            )}
                                        />

                                    </Grid>

                                    <Grid item xs={12} sm={12}>

                                        <TextField
                                            id='requester'
                                            name='requester'
                                            label='Solicitante'
                                            fullWidth
                                            multiline
                                            margin='dense'
                                            disabled
                                            value={values.requester}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />

                                    </Grid>

                                    <Grid item xs={12} sm={6}>

                                        <TextField
                                        
                                            id='extensionNumber'
                                            name='extensionNumber'
                                            label='Ramal'
                                            fullWidth
                                            multiline
                                            margin='dense'
                                            value={values.extensionNumber}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            type='number'

                                        />

                                    </Grid>

                                    <Grid item xs={12} sm={6}>

                                        <TextField
                                            id='email'
                                            name='email'
                                            type='email'
                                            label='E-mail'
                                            fullWidth
                                            multiline
                                            margin='dense'
                                            disabled
                                            value={values.email}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />

                                    </Grid>

                                </Grid>

                                <ButtonGroup 
                                    sx={{display: 'flex', width: '100%', justifyContent: 'flex-end', mt: 1}}
                                    disableElevation
                                >

                                    <Button variant='contained' color='error' onClick={handleCloseNewRS} disabled={isSubmitting}>
                                        Cancelar
                                    </Button>

                                    <Button variant='contained' color='primary' onClick={handleSubmit} disabled={isSubmitting || !isValid}>
                                        Enviar
                                    </Button>

                                </ButtonGroup>

                            </FormControl>     

                        )}

                </Formik>

            </Box>

      </TransitionsModal>
      
    );

};

export default NewServiceRequest;